routes.$inject = ['$routeProvider'];



export default function routes($routeProvider) {
  $routeProvider
    .when('/account', {
      template: require('./account.html'),
      controller: 'AccountCtrl',
      reloadOnSearch: false,
      app: true,
      resolve: {
        currentUser: ['CurrentUser', 'CurrentCustomer', 'CurrentAccount',
          '$q',
          (CurrentUser, CurrentCustomer, CurrentAccount, $q) => {
            let deferred = $q.defer();
            CurrentUser.api.get().then(user => {
              if (user.email) {
                $q.all([
                  CurrentCustomer.api.get(),
                  CurrentAccount.api.get()
                ]).then(() => {
                  deferred.resolve(user)
                }, response => deferred.reject(response))
              } else {
                deferred.reject()
              }
            }, response => deferred.reject(response))

            return deferred.promise;
          }
        ]
      }
    });
}



// WEBPACK FOOTER //
// ./project/pages/account/account.routes.js